import { CoursesRequests } from '@/modules/courses-requests/types';
import { BaseResponse } from '@/types';
import { Products } from '@/modules/products/types';

export namespace EditableCoursesRequest {
  import ProductPrices = Products.ProductPrices;

  export enum CoursesTypes {
    PAID = 'paid',
    FREE = 'free'
  }

  export interface Course {
    id: number,
    title: string,
    prices?: ProductPrices,
    in_stock?: number,
    required?: number,
  }

  export interface CoursesGroup {
    access: boolean,
    items: Course[]
  }

  export interface Courses {
    paid: CoursesGroup,
    free: CoursesGroup
  }

  export interface Staff {
    id: number,
    full_name: string,
    email: string,
    phone: string,
    roles: {
      string: string,
      slugs: string[]
    },
  }

  export interface SelectionLists {
    courses: Courses,
    staffs: Staff[]
  }

  export interface SelectionListsResponse extends BaseResponse {
    data: SelectionLists
  }

  export interface Response extends BaseResponse {
    data: {
      organization_id: number,
      filters: CoursesRequests.StaffsTableFilters,
      type: CoursesTypes,
      items: {
        courses: CoursesRequests.Course[],
        staffs: CoursesRequests.Staff[]
      }
    }
  }

  export interface ItemToSend {
    type: CoursesTypes,
    send: boolean,
    organization_id: number,
    items: CoursesRequests.Staff[]
  }

  export enum SendTypes {
    SAVE = 'save',
    SAVE_AND_SEND = 'save_and_send',
  }
}
